// CMS API client helper for MA Hvidevareservice

export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`/_api/public/content/${collectionName}`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : data?.items || [];
  } catch (err) {
    console.warn(`Could not load collection ${collectionName}:`, err);
    return [];
  }
}

export async function fetchCollectionV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        query.set(k, String(v));
      }
    });
    const qs = query.toString();
    const url = `/_api/public/v2/content/${collectionName}${qs ? `?${qs}` : ''}`;
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);
    return await res.json();
  } catch (err) {
    console.warn(`Could not load v2 collection ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

export async function fetchPageBySlug(slug) {
  try {
    const res = await fetch(`/_api/public/by-slug/${slug}`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.warn(`Could not load page by slug ${slug}:`, err);
    return null;
  }
}
